module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "TOC"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ContentsPage"
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/APRE"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/ABR"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/INT"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', [_vm._v("1. "), _c('a', {
    attrs: {
      "href": "#/Text/CH1"
    }
  }, [_vm._v("The perfect church (1:1–9)")])]), _vm._v(" "), _c('p', [_vm._v("2. "), _c('a', {
    attrs: {
      "href": "#/Text/CH2"
    }
  }, [_vm._v("Cliques at Corinth (1:10–17)")])]), _vm._v(" "), _c('p', [_vm._v("3. "), _c('span', {
    attrs: {
      "href": "#/Text/CH3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom—true and false (1:18–2:16)")])]), _vm._v(" "), _c('p', [_vm._v("4. "), _c('span', {
    attrs: {
      "href": "#/Text/CH4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fools for Christ’s sake (3:1–4:21)")])]), _vm._v(" "), _c('p', [_vm._v("5. "), _c('span', {
    attrs: {
      "href": "#/Text/CH5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flee fornication (5:1–13; 6:9–20)")])]), _vm._v(" "), _c('p', [_vm._v("6. "), _c('span', {
    attrs: {
      "href": "#/Text/CH6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Settled out of court (6:1–8)")])]), _vm._v(" "), _c('p', [_vm._v("7. "), _c('span', {
    attrs: {
      "href": "#/Text/CH7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage and singleness—two gifts from God (7:1–40)")])]), _vm._v(" "), _c('p', [_vm._v("8. "), _c('span', {
    attrs: {
      "href": "#/Text/CH8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom and sensitivity to others (8:1–13)")])]), _vm._v(" "), _c('p', [_vm._v("9. "), _c('span', {
    attrs: {
      "href": "#/Text/CH9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom to restrict our freedom (9:1–27)")])]), _vm._v(" "), _c('p', [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/Text/CH10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom and its dangers (10:1–11:1)")])]), _vm._v(" "), _c('p', [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/Text/CH11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christian community at worship (11:2–34)")])]), _vm._v(" "), _c('p', [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/Text/CH12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concerning spiritual gifts (12:1–31)")])]), _vm._v(" "), _c('p', [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/Text/CH13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If I have not love … (13:1–13)")])]), _vm._v(" "), _c('p', [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/Text/CH14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy and tongues (14:1–40)")])]), _vm._v(" "), _c('p', [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/Text/CH15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resurrection—past, present and future (15:1–58)")])]), _vm._v(" "), _c('p', [_vm._v("16. "), _c('span', {
    attrs: {
      "href": "#/Text/CH16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An international church (16:1–24)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/STG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Study Guide")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0